import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useRef, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { Transition } from 'react-transition-group';
import Button from '../button/Button';
import { CheckMark, Planet } from '../icons';
import { VisuallyHidden } from '../text';
import Box from '../layout/Box';
import Link from '../link/Link';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var SwitcherContainer = styled(Box).attrs({
  $styles: {
    position: 'relative',
    zIndex: 100
  }
}).withConfig({
  displayName: "LanguageSwitcher__SwitcherContainer",
  componentId: "sc-1n6vypn-0"
})([""]);
var PopupListWrapper = styled(Box).attrs(function (_ref) {
  var _ref$$styles = _ref.$styles,
      $styles = _ref$$styles === void 0 ? {} : _ref$$styles,
      theme = _ref.theme,
      $isExpanded = _ref.$isExpanded,
      $position = _ref.$position;
  return {
    $p: [theme.spaces.md, theme.spaces.lg],
    $styles: _objectSpread(_objectSpread({}, $styles), {}, {
      position: ['fixed', 'fixed', 'absolute'],
      top: $position === 'top' ? 'auto' : [null, null, 30],
      bottom: $position === 'top' ? [null, null, 30] : 'auto',
      left: [0, 0, -24],
      right: [0, 0, null],
      minWidth: 248,
      borderRadius: [null, null, 4],
      boxShadow: $isExpanded ? '0 4px 16px 0 rgba(5, 0, 56, 0.16)' : null,
      background: theme.colors.primaryWhite,
      textAlign: 'left',
      ':before': {
        content: "''",
        height: 6,
        position: 'absolute',
        left: 0,
        right: 0,
        top: $position === 'top' ? null : -6,
        bottom: $position === 'top' ? -6 : null
      }
    })
  };
}).withConfig({
  displayName: "LanguageSwitcher__PopupListWrapper",
  componentId: "sc-1n6vypn-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
      $isExpanded = _ref2.$isExpanded;
  return theme.normalizeStyles({
    bottom: $isExpanded ? [0, 0, null] : ['-100%', '-100%', null]
  });
});
var PopupList = styled(Box).attrs({
  as: 'ul',
  role: 'menu'
}).withConfig({
  displayName: "LanguageSwitcher__PopupList",
  componentId: "sc-1n6vypn-2"
})(["li:first-child{", ";}li:last-child{", ";}"], function (props) {
  return props.theme.normalizeStyles({
    paddingTop: [null, 0]
  });
}, function (props) {
  return props.theme.normalizeStyles({
    paddingBottom: [null, 0]
  });
});
var PopupListItem = styled(Box).attrs({
  as: 'li',
  $styles: {
    position: 'relative'
  },
  $py: 8
}).withConfig({
  displayName: "LanguageSwitcher__PopupListItem",
  componentId: "sc-1n6vypn-3"
})([""]);
var PopupTitle = styled(Box).attrs(function (props) {
  return {
    $styles: {
      display: ['block', 'block', 'none'],
      fontSize: 16,
      lineHeight: 24,
      fontWeight: 500,
      color: props.theme.colors.primaryIndigo,
      position: 'relative'
    },
    $pt: 8,
    $pb: 16
  };
}).withConfig({
  displayName: "LanguageSwitcher__PopupTitle",
  componentId: "sc-1n6vypn-4"
})([""]);
var PopupCloseButton = styled(Button).attrs({
  $styles: {
    width: 32,
    height: 32,
    position: 'absolute',
    top: '50%',
    right: -4,
    transform: 'translateY(-50%) rotate(45deg)'
  }
}).withConfig({
  displayName: "LanguageSwitcher__PopupCloseButton",
  componentId: "sc-1n6vypn-5"
})([""]);
var PopupCloseLine = styled(Box).attrs(function (props) {
  return {
    $styles: {
      background: props.theme.colors.primaryIndigo,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  };
}).withConfig({
  displayName: "LanguageSwitcher__PopupCloseLine",
  componentId: "sc-1n6vypn-6"
})(["&:first-child{", "}&:last-child{", "}"], function (props) {
  return props.theme.normalizeStyles({
    width: 22,
    height: '2px'
  });
}, function (props) {
  return props.theme.normalizeStyles({
    width: '2px',
    height: 22
  });
});
var duration = 250;
var collapsedStyles = {
  opacity: 0,
  visibility: 'hidden',
  transition: "box-shadow ".concat(duration, "ms 0ms, \n      transform ").concat(duration, "ms 0ms, \n      opacity ").concat(duration, "ms 0ms, \n      bottom ").concat(duration, "ms 0ms, \n      visibility 0ms ").concat(duration, "ms"),
  transform: 'translateY(0)'
};
var expandedStyles = {
  visibility: 'visible',
  transform: 'translateY(0)',
  transition: "visibility 0ms 0ms,\n  opacity ".concat(duration / 3, "ms 0ms,\n  bottom ").concat(duration, "ms 0ms,\n  transform ").concat(duration, "ms 0ms,\n  box-shadow ").concat(duration / 3, "ms\n    ").concat(duration / 4, "ms;\n  visibility: visible;\n  opacity: 1;\n  transform: translateY(0)\n  ")
};
var transitionStyles = {
  entering: _objectSpread({
    opacity: 0
  }, expandedStyles),
  entered: _objectSpread({
    opacity: 1
  }, expandedStyles)
};
var TYPOGRAPHY_STYLES = {
  fontSize: [18, 18, 16, 18, 18],
  lineHeight: [32, 22, 22, 24, 24]
};
var LanguageLink = styled(Link).attrs(function (_ref3) {
  var $isActive = _ref3.$isActive,
      theme = _ref3.theme;
  return {
    $styles: _objectSpread({
      color: $isActive ? theme.colors.primaryBlue : theme.colors.primaryIndigo,
      transition: "color ".concat(theme.animation.transitionDuration),
      textDecoration: 'none',
      ':hover': {
        color: theme.colors.primaryBlueHover
      },
      ':focus': _objectSpread({}, theme.focus.outlines.withOffset),
      width: '100%'
    }, TYPOGRAPHY_STYLES)
  };
}).withConfig({
  displayName: "LanguageSwitcher__LanguageLink",
  componentId: "sc-1n6vypn-7"
})([""]);
var LanguageCheckMark = styled(CheckMark).withConfig({
  displayName: "LanguageSwitcher__LanguageCheckMark",
  componentId: "sc-1n6vypn-8"
})(["", ""], function (props) {
  return props.theme.normalizeStyles({
    position: 'absolute',
    top: '50%',
    right: 0,
    transform: 'translateY(-50%)'
  });
});

var LanguagePopup = function LanguagePopup(props) {
  var isExpanded = props.isExpanded,
      translations = props.translations,
      onCloseClick = props.onCloseClick,
      onSelect = props.onSelect,
      position = props.position,
      currentLocale = props.currentLocale,
      setExpanded = props.setExpanded;
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Transition, {
    "in": isExpanded,
    timeout: 250,
    children: function children(state) {
      return /*#__PURE__*/_jsxs(PopupListWrapper, {
        $isExpanded: isExpanded,
        $styles: _objectSpread(_objectSpread({}, !isExpanded ? collapsedStyles : {}), transitionStyles[state]),
        $position: position,
        children: [/*#__PURE__*/_jsxs(PopupTitle, {
          children: [/*#__PURE__*/_jsx(Box, {
            $styles: _objectSpread({}, TYPOGRAPHY_STYLES),
            children: "Choose website language"
          }), /*#__PURE__*/_jsxs(PopupCloseButton, {
            onClick: onCloseClick,
            children: [/*#__PURE__*/_jsx(PopupCloseLine, {}), /*#__PURE__*/_jsx(PopupCloseLine, {})]
          })]
        }), /*#__PURE__*/_jsx(PopupList, {
          children: translations.map(function (t) {
            return /*#__PURE__*/_jsxs(PopupListItem, {
              children: [/*#__PURE__*/_jsx(LanguageLink, {
                "data-locale": t.locale,
                "data-testid": "item-".concat(t.locale),
                onClick: function onClick(e) {
                  setExpanded(false);
                  onSelect(e, t);
                },
                href: t.url,
                $isActive: t.locale === currentLocale.locale,
                children: t.localeLabel || t.locale
              }), t.locale === currentLocale.locale && /*#__PURE__*/_jsx(LanguageCheckMark, {
                color: theme.colors.primaryBlue
              })]
            }, t.locale);
          })
        })]
      });
    }
  });
};

var SwitcherIcon = styled(Planet).withConfig({
  displayName: "LanguageSwitcher__SwitcherIcon",
  componentId: "sc-1n6vypn-9"
})(["", ""], function (props) {
  return props.theme.normalizeStyles({
    marginRight: [8, 8, 0, 8, 8],
    width: 24,
    height: 24
  });
});
var SwitcherCurrentLocale = styled(Box).attrs({
  $styles: {
    textTransform: 'uppercase'
  }
}).withConfig({
  displayName: "LanguageSwitcher__SwitcherCurrentLocale",
  componentId: "sc-1n6vypn-10"
})([""]);
var SwitcherButton = styled(Button).attrs(function (_ref4) {
  var $color = _ref4.$color,
      theme = _ref4.theme,
      $isActive = _ref4.$isActive;
  var activeColor = $color === 'white' ? theme.colors.outspoken : theme.colors.primaryBlueHover;
  return {
    $styles: {
      fontSize: [18],
      lineHeight: 24,
      display: 'flex',
      alignItems: 'center',
      color: $isActive ? activeColor : $color === 'white' ? theme.colors.primaryWhite : theme.colors.primaryIndigo,
      ':hover': {
        color: activeColor
      },
      ':focus': _objectSpread({}, theme.focus.outlines.withOffset),
      transition: 'color 250ms ease'
    }
  };
}).withConfig({
  displayName: "LanguageSwitcher__SwitcherButton",
  componentId: "sc-1n6vypn-11"
})([""]);

var LanguageSwitcher = function LanguageSwitcher(props) {
  var color = props.color,
      currentLocale = props.currentLocale,
      translations = props.translations,
      onSelect = props.onSelect;

  var _useState = useState(translations),
      translationsState = _useState[0],
      setTranslationsState = _useState[1];

  var _useState2 = useState(false),
      isExpanded = _useState2[0],
      setExpanded = _useState2[1];

  var ref = useRef(null);

  if (!currentLocale || translations.length === 0) {
    return null;
  }

  useOnClickOutside(ref, function () {
    if (isExpanded) {
      setExpanded(false);
    }
  });
  useEffect(function () {
    if (!(translations !== null && translations !== void 0 && translations.length)) {
      return;
    } // * put english first and sort the rest


    setTranslationsState(translations.sort(function (a, b) {
      var _a$locale, _b$locale;

      var EN = 'en';
      var labelA = a.localeLabel || '';
      var labelB = b.localeLabel || '';

      if (((_a$locale = a.locale) === null || _a$locale === void 0 ? void 0 : _a$locale.toLowerCase()) == EN) {
        return -1;
      }

      if (((_b$locale = b.locale) === null || _b$locale === void 0 ? void 0 : _b$locale.toLowerCase()) == EN) {
        return +1;
      }

      if (labelA > labelB) {
        return 1;
      }

      if (labelB > labelA) {
        return -1;
      }

      return 0;
    }));
  }, [translations]);
  return /*#__PURE__*/_jsxs(SwitcherContainer, {
    "data-track-place": "Language Switcher",
    ref: ref,
    children: [/*#__PURE__*/_jsxs(SwitcherButton, {
      "data-testid": "SwitcherButton",
      "aria-haspopup": true,
      "aria-expanded": isExpanded,
      $isActive: isExpanded,
      onClick: function onClick() {
        return setExpanded(!isExpanded);
      },
      $color: color,
      children: [props.hideSelectedLabel ? /*#__PURE__*/_jsx(SwitcherIcon, {
        style: {
          marginRight: 0
        },
        "aria-hidden": "true"
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SwitcherIcon, {
          "aria-hidden": "true"
        }), /*#__PURE__*/_jsx(SwitcherCurrentLocale, {
          "aria-hidden": true,
          children: currentLocale.locale
        })]
      }), /*#__PURE__*/_jsxs(VisuallyHidden, {
        children: ["Current language is: ", currentLocale.localeLabel || currentLocale.locale]
      })]
    }), /*#__PURE__*/_jsx(LanguagePopup, {
      setExpanded: setExpanded,
      onSelect: onSelect,
      isExpanded: isExpanded,
      currentLocale: currentLocale,
      translations: translationsState,
      onCloseClick: function onCloseClick() {
        return setExpanded(false);
      },
      position: props.position
    })]
  });
};

export default Object.assign(LanguageSwitcher, {
  SwitcherCurrentLocale: SwitcherCurrentLocale
});